import { createApi } from "@reduxjs/toolkit/query/react";
import { errorBaseQuery } from "../errorBaseQuery";
import {
  ADV_PROJECTS,
  BALANCE,
  BLOGGER_CHANNELS,
  BLOGGER_OFFERS,
  CART,
  CART_MANAGER,
  CART_PUB,
  CATALOG,
  CHAT,
  LEGALS,
  RECOMMEND_CARDS,
  AGENCY_PROJECTS_CUSTOMER,
  AGENCY_PROJECTS_PUBLISHER,
  AGENCY_PROJECTS_MANAGER,
  CART_SHORT,
  CART_PUB_SHORT,
} from "@shared/api/tags";

export const baseApi = createApi({
  baseQuery: errorBaseQuery(import.meta.env.VITE_BASE_URL, "include"),
  reducerPath: "api",
  endpoints: () => ({}),
  tagTypes: [
    CART_PUB,
    CART_PUB_SHORT,
    BLOGGER_CHANNELS,
    CART,
    CART_SHORT,
    CART_MANAGER,
    CATALOG,
    RECOMMEND_CARDS,
    BALANCE,
    BLOGGER_OFFERS,
    ADV_PROJECTS,
    LEGALS,
    CHAT,
    AGENCY_PROJECTS_MANAGER,
    AGENCY_PROJECTS_PUBLISHER,
    AGENCY_PROJECTS_CUSTOMER,
  ],
});
